<div class="section1 d-flex">
  <div class="section1__double-line d-flex">
    <div class="line1"></div>
    <div class="line2 bg-primary"></div>
  </div>
  <div class="section1__content d-flex flex-column flex-lg-row">
    <div class="text-box text-white">
      <h2>Know your options</h2>
      <p class="mb-4">
        Advancements in management of autoimmune type 1 diabetes may offer ways
        to help. Talk to your or your loved one’s doctor about what could come
        next. You or your loved one may be able to participate in a clinical
        trial or explore other options.
      </p>
    </div>
    <div class="image-box position-relative flex-shrink-0">
      <picture [data]=" {
        image: 'benefits-of-knowing/section1-image',
        webp: true,
        altext: 'A mother playing Jenga with her two daughters',
        format: '',
        width: '709',
        height: '539',
        mobile: true,
        fill: true,
        classes: 'img-fluid w-100 object-fit-cover',
      }"></picture>
    </div>
  </div>
</div>